module.exports = __webpack_public_path__ + "assets/img/o2.56302a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/o2.jpg
// module id = g59Y
// module chunks = 1